import certificationBadges from "/images/certification-badges.png";

export function MiniFooter() {
  return (
    <footer className="mt-4 flex flex-col items-center gap-3">
      <div className="text-center">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wider">
          Security & Compliance Certifications
        </p>
      </div>

      <div className="flex justify-center">
        <img
          src={certificationBadges}
          alt="Cyber Essentials, TISAX, ISO 27001, ISO 27701 certifications"
          className="w-full max-w-sm h-auto max-h-14 object-contain"
        />
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2 pt-1 text-sm text-muted-foreground">
          <a
            href="/terms-of-service"
            className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
          >
            Terms and Conditions
          </a>
          <span className="text-sidebar-foreground/50">|</span>
          <a
            href="/privacy-policy"
            className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
          >
            Privacy Policy
          </a>
          <span className="text-sidebar-foreground/50">|</span>
          <a
            href="/gdpr-policy"
            className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
          >
            GDPR Policy
          </a>
      </div>
    </footer>
  );
}